module.exports = __webpack_public_path__ + "img/garage-car.426e1372.svg";